module.exports = __webpack_public_path__ + "img/bg-image-6.23a3ea8a.jpg";